// Copyright (c) 2019-present Ithpower, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import {useContext, useEffect} from 'react';
import {Button} from 'antd';

import {loadEnterpriseSummaryById} from 'server/actions/organization';
import Icon from 'components/icon';
import GlobalContext from 'context/global_context';
import ChargeCode from 'images/charge_code.png';
import blue from 'images/info_bg/blue.png';
import green from 'images/info_bg/green.png';
import yellow from 'images/info_bg/yellow.png';

const InviteKey = 'OpenInvite';

const EnterpriseInfo = () => {
    const {
        enterpriseSummary,
        setEnterpriseSummary,
        enterpriseInfo,
        loadEnterpriseInfo,
    } = useContext(GlobalContext);

    useEffect(() => {
        // 先拉取summary 再拉取订单信息
        if (enterpriseInfo === undefined) {
            loadEnterpriseInfo();
        }
        if (enterpriseSummary === undefined) {
            loadEnterpriseSummaryById().then(({data}) => {
                if (data) {
                    setEnterpriseSummary(data);
                }
            });
        }
    }, []);

    const handleInvite = () => {
        window.top?.window?.postMessage?.(InviteKey, '*');
    };

    const renderDataGroup = () => {
        let balance = 0;
        let totalNumber = 0;
        let usedNumber = 0;
        if (enterpriseSummary) {
            totalNumber = enterpriseSummary.staff_limit_count;
            usedNumber = enterpriseSummary.staff_count;
            balance = totalNumber - usedNumber;
        }

        let orderContent = '';
        if (enterpriseInfo && enterpriseInfo.props) {
            if (enterpriseInfo.props.task) {
                orderContent += `${orderContent ? '、' : ''}协作`;
            }
            if (enterpriseInfo.props.objective) {
                orderContent += `${orderContent ? '、' : ''}目标`;
            }
            if (enterpriseInfo.props.performance) {
                orderContent += `${orderContent ? '、' : ''}绩效`;
            }
        }

        return (
            <div className='enterprise_data-order-list'>
                <div className='enterprise_data-order-group'>
                    <h2 className='enterprise_data-group-title'>
                        <Icon
                            type='quanyi'
                            size={24}
                            style={{marginRight: 8, verticalAlign: 'bottom'}}
                        />
                        {'权益数据'}
                        <span className='enterprise_data-group-subtitle'>{orderContent}</span>
                    </h2>
                    <div className='enterprise_data-group-content'>
                        <div
                            className='enterprise_data-field-item'
                            style={{backgroundImage: `url(${blue})`}}
                        >
                            <p className='enterprise_data-label'>
                                {'账户剩余/总数（个）'}
                            </p>
                            <div
                                className='enterprise_data-item-content'
                                style={{color: '#0067FF'}}
                            >
                                <span style={{fontSize: '30px'}}>{balance}</span>
                                <span style={{fontSize: '18px'}}> / {totalNumber}</span>
                            </div>
                            <Button
                                type='primary'
                                onClick={handleInvite}
                            >
                                <Icon type='plus'/>
                                {'邀请成员'}
                            </Button>
                        </div>
                        <div
                            className='enterprise_data-field-item'
                            style={{backgroundImage: `url(${green})`}}
                        >
                            <p className='enterprise_data-label'>
                                {'已开通账户（个）'}
                            </p>
                            <div className='enterprise_data-item-content'>
                                <span style={{fontSize: '30px', color: '#0FC6C2'}}>{usedNumber}</span>
                            </div>
                        </div>
                        <div
                            className='enterprise_data-field-item'
                            style={{backgroundImage: `url(${yellow})`}}
                        >
                            <p className='enterprise_data-label'>
                                {'如需扩容，请联系客服'}
                            </p>
                            <div className='enterprise_data-item-content'>
                                <img
                                    className='contact-img'
                                    src={ChargeCode}
                                    alt='qrcode'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='backend-enterprise_info'>
            <div className='enterprise_info-container'>
                {renderDataGroup()}
            </div>
        </div>
    );
};

export default EnterpriseInfo;
